



























































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ResPostSubscription } from '@/gen';
import { calcNextPayDt } from '@/common/subscriptionUtils';
import { SubscriptionPackageItem } from '@/models/SubscriptionPackageItem';

@Component
export default class RegisteredComplete extends Vue {
  // サブスクパッケージID
  @Prop()
  subscriptionPackageID!: string;
  // サブスク登録APIレスポンス
  @Prop()
  resPostSubscription!: ResPostSubscription;
  // サブスクパッケージ情報
  @Prop()
  subscriptionPackageInfo!: SubscriptionPackageItem;
  // 次回更新料金無料判定フラグ
  @Prop()
  isNextUpdateForFree!: boolean;
  // サブスク情報取得時エラー
  @Prop()
  fetchError!: boolean;

  get nextPayDt() {
    return calcNextPayDt(
      this.resPostSubscription.pay_interval,
      this.resPostSubscription.start_dt
    );
  }

  // 登録完了をトリガーにするために、パッケージ名をdataLayerにプッシュ
  mounted() {
    this.$dataLayer.push({
      event: 'subscribe_completion',
      package_name: this.resPostSubscription.package_name
    });
  }
}
